import React from "react";

const Title = () => {
  return <>Event</>;
};

export default Title;
